import React from "react";
import CircleSteps from "../../../../src/components/navigation/CircleSteps";
import ProgressBar from "../../../../src/components/navigation/ProgressBar";
import SelectPlan from "./form";

const particularSteps = [
  {
    name: "Tipo de cuenta",
    description: "Particular",
    href: "#",
    status: "complete",
  },
  {
    name: "Ubicación y precio",
    description: "Define el tipo de inmueble y operación",
    href: "#",
    status: "complete",
  },
  {
    name: "Amenidades",
    description: "¿Qué pueden encontrar en la propiedad?",
    href: "#",
    status: "complete",
  },
  {
    name: "Descripción y fotos",
    description: "Detalles más específicos",
    href: "#",
    status: "complete",
  },
  {
    name: "Pago",
    description: "Contrata tu plan y accede a PRO",
    href: "#",
    status: "current",
  },
];

export default function Index() {
  return (
    <div className="relative">
      <div className="space-y-1 bg-gray-100 p-3 md:hidden ">
        <p className="text-center font-semibold uppercase leading-4">SELECCIONA TU PLAN</p>
        <p className="text-center">Contrata tu plan y accede a PRO</p>
        <ProgressBar
          config={{
            step: 5,
            total: 5,
          }}
        />
      </div>
      <div className="grid-cols-3 md:grid  ">
        <div className="col-span-1 hidden min-h-screen bg-gray-100 pt-16 md:block ">
          <div className="m-auto block w-3/4 space-y-3">
            <p className="text-5xl font-extrabold leading-none text-black">
              Publica en Casas y Terrenos
            </p>
            <p className="text-lg font-semibold uppercase leading-6 tracking-wider">
              Toma al rededor de 7 minutos
            </p>
            <p className="pb-4 text-lg leading-8 tracking-wider">Contrata desde $600 + iva</p>
            <div className="hidden md:block">
              <CircleSteps steps={particularSteps} />
            </div>
          </div>
        </div>
        <div className="col-span-2 block ">
          <div className="m-auto flex w-full px-2 md:px-5 pt-3 md:min-h-screen md:pt-4 lg:w-full">
            <SelectPlan />
          </div>
        </div>
      </div>
    </div>
  );
}
